"use strict";

require("../../style/index.css");

require("../../grid/style/css");